import DatasetIcon from "../../../public/assets/chart-line-variant.svg";

export default DatasetIcon;
